export interface DeviceID {
	id: string;
	channel: number | '0';
}

export function is_device(obj): obj is DeviceID {
	return typeof obj !== 'undefined' && typeof obj.id === 'string';
}
